export default "__VITE_ASSET__0361c11c__"